import { AppImages } from '@/app'
import { LatestSectionItem } from '@/types'

export const LatestPosts: LatestSectionItem[] = [
  { id: 0, index: 0, file: AppImages.LatestPost1 },
  { id: 1, index: 1, file: AppImages.LatestPost5 },
  { id: 2, index: 2, file: AppImages.LatestPost6 },
  { id: 3, index: 3, file: AppImages.LatestPost7 },
]
